window.addEventListener("resize", function () {
  // Force Safari to recalculate clip paths
  const elements = document.querySelectorAll(".post-item figure")
  elements.forEach((el) => {
    // Toggle a class or attribute to force recalculation
    el.style.display = "none"
    // Force reflow
    void el.offsetWidth
    el.style.display = ""
  })
})
